import { faqData } from '@/mocks/tanhua';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            常见问答
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            关于探花系列平台的常见问题解答，帮助你快速了解本站
          </p>
        </div>

        <div className="max-w-3xl mx-auto grid gap-4">
          {faqData.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6"
            >
              <h3 className="text-base md:text-lg font-heading text-foreground-950 mb-3 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-500 flex items-center justify-center text-xs font-medium">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed pl-9">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}